import React from 'react';
import { Link } from 'react-router-dom';


export const Page500 = () => {
    const onBack = () => {
        window.history.back();
    }
    return (
        <div className="ex-pages">
            <div className="content-center">
                <div className="content-desc-center">
                    <div className="container">
                        <div className="card mo-mt-2">
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col-lg-4 offset-lg-1">
                                        <div className="ex-page-content">
                                            <h1 className="text-dark">500!</h1>
                                            <h4 className="mb-4">Internal Server Error</h4>
                                            <p className="mb-5"> There was an error. Please try again later.</p>
                                            <button className="btn btn-secondary mb-5 waves-effect waves-light mr-3" onClick={(e) => onBack()}><i className="fas fa-arrow-left"></i>&nbsp; Back</button>
                                            <Link className="btn btn-primary mb-5 waves-effect waves-light" to="/"><i className="mdi mdi-home"></i> Back to Home</Link>
                                        </div>

                                    </div>
                                    <div className="col-lg-5 offset-lg-1">
                                        <img src="/assets/images/error.svg" alt="veltrix" className="img-fluid mx-auto d-block" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}